import { createUseQuery } from 'api/common/createUseQuery'
import { fetchMe } from 'api/fetchers/fetchMe'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useMe = createUseQuery({
  queryKey: ApiQueryKeys.MT_USERS_ME,
  fetcher: fetchMe,
  selector: res =>
    (res?.data as {
      persistentPlatformFile: {
        description: string | null
        extension: string | null
        fileKey: string | null
        id: string
        metaData: any
        mimeType: string | null
        name: string
        originalName: string
        size: number | null
        thumbnailUrl: string | null
        type: string | null
        url: string | null
      } | null
    }) ?? ({ persistentPlatformFile: null } as { persistentPlatformFile: null }),
})
